import { useEffect, useRef } from 'react';

import { App } from 'antd';

import { useIntl, useModel, useRequest } from '@umijs/max';

import { findDateRangeDefects, getThresholdDefects } from './index';
import { FindDateRangeDefectsRequest, ThresholdDefectsResponse } from './types';

export const useGetDefects = () => {
  const intl = useIntl();
  const { message } = App.useApp();
  const { setDefectsColors } = useModel('defectsColors');
  const hasRetriedRef = useRef(false);

  const request = useRequest(getThresholdDefects, {
    cacheKey: 'getThresholdDefects',
    onError: () => {
      message.error(intl.formatMessage({ id: 'common.fetch.failure' }));
    },
    onSuccess: (data: ThresholdDefectsResponse[]) => {
      setDefectsColors(data.filter(item => item.isThreshold).map(item => [item.name, item.color]));
    },
    staleTime: Infinity,
  });

  useEffect(() => {
    if (request.loading || request.data || hasRetriedRef.current) {
      return;
    }

    hasRetriedRef.current = true;
    void request.refresh();
  }, [request.data, request.loading, request.refresh]);

  return request;
};

export const useFindDateRangeDefects = (payload: null | Partial<FindDateRangeDefectsRequest>) => {
  const intl = useIntl();
  const { message } = App.useApp();
  const { searchVersion } = useModel('showSamplesDetails');

  return useRequest(() => findDateRangeDefects(payload), {
    cacheKey: 'findDateRangeDefects',
    onError: () => {
      message.error(intl.formatMessage({ id: 'common.fetch.failure' }));
    },
    ready: !!payload,
    refreshDeps: [JSON.stringify(payload), searchVersion],
  });
};
